import { Button } from '../../../styles/GlobalComponents';
import { Link } from 'react-router-dom';
import { Box, Flexed } from '../../../styles/GlobalComponents';
import { Icon, IconApproveNFTSuccess } from '../../../styles/Icons';
import { P2 } from '../../../styles/FontStyles';
import { DASHBOARD, ORDERS, TRAVEL_PACKAGES } from '../../../routes/routes';

export const Success = () => {
  return (
    <>
      <Box gray>
        <Flexed column center>
          <Flexed>
            <Icon mb='20'>
              <IconApproveNFTSuccess />
            </Icon>
          </Flexed>
        </Flexed>

        <P2 bold center mb='20'>
          The recipient will see the gifted subscription available in their
          account shortly.
        </P2>

        <Flexed column center>
          <Link to={TRAVEL_PACKAGES}>
            <Button w='200px' negative onClick={() => {}}>
              My Products
            </Button>
          </Link>
        </Flexed>
      </Box>
    </>
  );
};
